import { ContentWrapper } from 'src/components/common/wrapper/content/wrapper';
import { FilterWrapper } from 'src/components/common/wrapper/filter/wrapper';
import {
  Actions,
  AppArea,
  Subjects,
  UserMergeRequestListFilterInput,
  UserMergeRequestStatus,
} from 'src/graphql/generated/graphql';
import { useTable } from 'src/hooks/use-table';
import { TableWrapper } from 'src/components/common/wrapper/table/wrapper';
import { Filter } from './merge-requests/filter';
import { Link } from 'react-router-dom';
import { Routes } from 'src/components/common/router/constants';
import { Button, Callout, Tabs } from '@otp/ui';
import { useTranslation } from 'react-i18next';
import { Can } from 'src/utils/can';
import { UserMergeRequestsList } from './merge-requests/list';
import { useState } from 'react';
import { UsersLookupList } from './users-lookup/list';
import { CreateAndApproveMergeEidButton } from './create-and-approve-merge-eid-button';

enum TabType {
  PendingMergeRequests = 'pending-merge-requests',
  UsersLookup = 'users-lookup',
}

export const UserMergeRequestList = () => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'user-merge-requests.list',
  });

  const [activeTab, setActiveTab] = useState(TabType.PendingMergeRequests);

  const tabs = [
    {
      label: t('tabs.pending-merge-requests'),
      value: TabType.PendingMergeRequests,
    },
    { label: t('tabs.users-lookup'), value: TabType.UsersLookup },
  ];

  const { filter, onFilterChange, defaultFilter } = useTable<
    UserMergeRequestListFilterInput,
    Record<any, any>
  >({ defaultFilter: { status: UserMergeRequestStatus.Pending } });

  return (
    <>
      <Can
        I={Actions.Read}
        a={Subjects.UserMergeRequests}
        appArea={AppArea.Admin}
      >
        <FilterWrapper>
          <Filter
            onSubmit={onFilterChange}
            defaultFilter={defaultFilter}
            searchOnly={activeTab === TabType.UsersLookup}
          />
        </FilterWrapper>

        <ContentWrapper>
          <TableWrapper>
            <Tabs
              className="mb-2 mt-4"
              tabs={tabs}
              onChange={(_, value) => setActiveTab(value)}
              value={activeTab}
              extra={
                <div className="flex justify-end gap-2">
                  <Can
                    I={Actions.Write}
                    a={Subjects.UserMergeRequests}
                    appArea={AppArea.Admin}
                  >
                    <div className="flex justify-end">
                      <Link to={Routes.userMergeRequestsCreate.path}>
                        <Button variant="contained">
                          {t('add-user-merge-request-button')}
                        </Button>
                      </Link>
                    </div>
                  </Can>
                  <CreateAndApproveMergeEidButton />
                </div>
              }
            />

            {activeTab === TabType.PendingMergeRequests && (
              <>
                {filter.status === UserMergeRequestStatus.Pending && (
                  <Callout severity="info" className="my-4">
                    {t('pending-merge-requests-description')}
                  </Callout>
                )}
                <UserMergeRequestsList filter={filter} />
              </>
            )}

            {activeTab === TabType.UsersLookup && (
              <UsersLookupList
                filter={{
                  search: filter.search,
                }}
              />
            )}
          </TableWrapper>
        </ContentWrapper>
      </Can>
    </>
  );
};
